module.exports = __webpack_public_path__ + "img/position.34ad6aa5.png";